import React from "react"
import { graphql } from "gatsby"
import styled from "styled-components"
import { rem } from "polished"
import { Meta } from "@outdoormap/gatsby-plugin-brand-sites"

import Layout from "../components/layout"
import PostsHighlights from "../components/posts-highlights"
import PostCard from "../components/post-card"
import PhotoHero from "../components/photo-hero"

const Grid = styled.ul`
  ${({ theme }) => theme.grid.container()}

  margin-top: ${rem(40)};
  margin-bottom: ${rem(40)};

  @media ${({ theme }) => theme.mq.mediumDown} {
    margin-top: ${rem(20)};
    margin-bottom: ${rem(20)};
  }

  > ul {
    ${({ theme }) => theme.grid.grid()}
    ${({ theme }) => theme.grid.gridGutterX()}
    ${({ theme }) => theme.grid.gridGutterY(30)}

    > li {
      ${({ theme }) => theme.grid.cell(4)}

      @media ${({ theme }) => theme.mq.xlargeDown} {
        ${({ theme }) => theme.grid.cell(6)}
      }

      @media ${({ theme }) => theme.mq.smallDown} {
        ${({ theme }) => theme.grid.cell(12)}
      }
    }
  }
`

const Description = styled.div`
  ${({ theme }) => theme.grid.container(`xnarrow`)}

  margin-top: ${rem(50)};

  @media ${({ theme }) => theme.mq.mediumDown} {
    margin-top: ${rem(20)};
  }

  p {
    font-size: ${rem(18)};
    line-height: ${rem(24)};
    color: ${({ theme }) => theme.colors.gray};
    margin-top: ${rem(20)};
  }
`

const NewsPage = ({ data: { config, news, img } }) => {
  const highlightItemsMax = 3
  let highlightItems = null
  let gridItems = null

  if (news && news.nodes.length >= highlightItemsMax) {
    highlightItems = news.nodes.slice(0, highlightItemsMax)
    gridItems = news.nodes.slice(highlightItemsMax)
  } else {
    highlightItems = news.nodes
  }

  return (
    <Layout>
      <PhotoHero
        title={config.pages.news.title}
        intro={config.pages.news.intro}
        image={img}
      />

      {config.pages.news.description && (
        <Description
          dangerouslySetInnerHTML={{
            __html: config.pages.news.description,
          }}
        />
      )}

      {highlightItems && !!highlightItems.length && (
        <PostsHighlights data={highlightItems} />
      )}

      {gridItems && !!gridItems.length && (
        <Grid>
          <ul>
            {gridItems.map((item, i) => (
              <li key={i}>
                <PostCard data={item} />
              </li>
            ))}
          </ul>
        </Grid>
      )}
    </Layout>
  )
}

export default NewsPage

export const Head = ({ data: { config } }) => {
  return <Meta data={{ title: config.pages.news.title }} />
}

export const pageQuery = graphql`
  query {
    config: configJson {
      pages {
        news {
          title
          intro
          description
        }
      }
    }

    news: allNewsJson(sort: { publish_at: DESC }) {
      nodes {
        ...NewsCardFragment
      }
    }

    img: file(
      sourceInstanceName: { eq: "images" }
      relativePath: { eq: "content/discover.jpg" }
    ) {
      childImageSharp {
        gatsbyImageData(width: 1920)
      }
    }
  }
`
